import gql from 'graphql-tag';

export const updateIBeaconMutation = gql`
  mutation ($input: IBeaconUpdateInput) {
    updateIBeacon(input: $input)
    {
      deviceId
      application {
        applicationId
      }
      name
      model {
        modelId
        name
        remark
      }
      serial
      mac
      region
      longitude
      latitude
      distance
      remark
      optional
      date
      uuid
      major
      minor
      battery
      active
      title
      text
      x
      y
      z
    }
  }
`
